import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Pagination } from '@mui/material';
import axios from '../../helpers/axios';
import Highcharts from "highcharts";
import { formatDate, formatTime, isEmailAllowed } from '../../helpers/custom';
import {
  format,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  subMonths
} from "date-fns";
import { Grid, Card, CardContent, CardActions, CardHeader, IconButton, Button, Menu, MenuItem, Modal, Box, Divider, FormControl, Select, InputLabel, TextField, Typography, Backdrop, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, ButtonGroup } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import DiversionHeader from './DiversionHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import fileDownload from 'js-file-download';
import { NumericFormat } from 'react-number-format';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};
function CustomPagination({ count, page, onChange }: { count: number, page: number, onChange: (event: React.ChangeEvent<unknown>, value: number) => void }) {
    return (
        <Pagination
            count={count}
            page={page}
            onChange={onChange}
            color="primary"
            shape="rounded"
            variant="outlined"
            showFirstButton
            showLastButton
        
        
        
        />
    );
} 

function CustomToolbar() {
    return (
        <GridToolbarContainer className='exportButton'>
            <GridToolbarExport variant='contained' csvOptions={{ fileName: 'Outgoing-waste' }} />
        </GridToolbarContainer>
    );
}

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    pageSize: number;
    rowCount: number;
    filter: string;
    gst:string;
    filter_route_id: any;
    outGoingWasteList: any[];
    materialGraphData: any[],
    material_types: any;
    types: any[];
    routes: any[];
    anchorEl: any;
    showAddWaste: boolean;
    graphType: string;
    /**Add waste by Vehicle Form Data */
    route_id?: any;
    unit?: string;
    date?: string | null;
    time?: string | null;
    price_per_unit?: number;
    total_price?: number;
    graphLoading: boolean;
    material?: any;
    material_type?: any;
    buyers: any[];
    buyer_name: string;
    waste_quantity?: number;
    buyer: string;
    receipt_id: string;
    description: string;
    /**Add waste by Vehicle Form Data */
    showExportToCsv: boolean;
    fromDate?: string | null;
    invoice_no: string; 
    toDate?: string | null;
    units: any[];
    entryId: string;
    outgoingWasteId: string;
    showDeleteDialog: boolean;
    outgoingWasteFlowDuration: string;
    showMaterialGraph: boolean;
    graphDuration: string;
    showGraphCustom: boolean;
    graphFrom: string | null;
    graphTo: string | null;
    showCustomDateFilter: boolean;
    customFromDate?: string | null;
     dateFilterLoading:boolean;
    customToDate?: string | null;
      graphCustomFromDate: string|null,
  graphCustomToDate:string| null,
    durationType: string;
    currentPage:number
}

class OutgoingWaste extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            currentPage: 0,
            pageSize: 10,
            rowCount: 0,
            buyer_name: '',
            filter: '',
            filter_route_id: 'all',
            graphType: "material",
            outGoingWasteList: [],
            buyers: [],
            graphLoading: false,
            materialGraphData: [],
            material_types: [],
            types: [],
            invoice_no:"",
            routes: [],
            anchorEl: null,
            showAddWaste: false,
            graphCustomFromDate: null,
            graphCustomToDate: null,
            route_id: '',
            unit: '',
            gst:'',
            date: null,
            time: formatDate(formatDate(new Date(), "Y-m-d")+" 00:00:00", "Y-m-d H:i:s"),
            price_per_unit: 0,
            showMaterialGraph: false,
            graphDuration: "current_month",
            showGraphCustom: false,
            graphFrom: null,
            graphTo: null,
            total_price: 0,
            material: '',
            material_type: '',
            waste_quantity: 0,
            buyer: '',
            receipt_id: '',
            description: '',
            showExportToCsv: false,
            fromDate: null,
            toDate: null,
            units: [],
            entryId: '',
            outgoingWasteId: '',
            showDeleteDialog: false,
            outgoingWasteFlowDuration: '',
            showCustomDateFilter: false,
            dateFilterLoading: false,
            customFromDate: null,
            customToDate: null,
            durationType: ''
        }
    }

    public componentDidMount(): void {
        this.fetchOutGoingWasteList();
        this.fetchRoutes();
        this.fetchUnits();
        this.fetchMaterialTypes();
        this.fetchBuyers();
    }
  //   componentDidUpdate (prevProps:any, prevState:any) {
  //         if (!prevState.showMaterialGraph && this.state.showMaterialGraph) {
      
  //             setTimeout(() => {
  //                 this.renderMaterialGraph();
  //             }, 50);
  //         }
  //         if (
  //   prevState.materialGraphData !== this.state.materialGraphData &&
  //   this.state.showMaterialGraph
  // ) {
  //   this.renderGraph();
  // }
  //     }
  renderGraph() {
  if (this.state.graphType === "material") {
    this.renderMaterialGraph();
  } else if (this.state.graphType === "buyer") {
    this.renderBuyerGraph();
  } else if (this.state.graphType === "date") {
    this.renderDateGraph();
  }
}
renderBuyerGraph() {
  const container = document.getElementById("incomingGraphContainer");
  if (!container) return;

  const data = this.state.materialGraphData;

  if (!data || data.length === 0) {
    Highcharts.chart(container, {
      title: {
        text: "No data available",
        y: 180,
        style: { color: "#999", fontSize: "16px" }
      },
      credits: { enabled: false }
    });
    return;
  }

  const fallbackColors = [
    "#3B3EAC", "#56B1BF", "#FE9C78", "#C84B31",
    "#FFC85B", "#2F2E41", "#7C9797",
    "#CCA85A", "#FF8F66"
  ];

  const buyers = data.map((b: any) => b.buyer);

  const series: any[] = [];
  let colorIndex = 0;

  data.forEach((buyer: any, index: number) => {
    buyer.materials.forEach((material: any) => {
      material.subtypes.forEach((sub: any) => {

        series.push({
          type: "bar",
          name: sub.subtype,
          color: fallbackColors[colorIndex % fallbackColors.length],
          data: data.map((_: any, i: number) =>
            i === index
              ? {
                  y: Number(sub.quantity) || 0,
                  customData: {
                    subtype: sub.subtype,
                    quantity: Number(sub.quantity) || 0,
                    avg_price: Number(sub.avg_price_per_unit) || 0,
                    total_value: Number(sub.total_value) || 0
                  }
                }
              : 0
          )
        });

        colorIndex++;
      });
    });
  });

  const barHeight = 50;
  const calculatedHeight = Math.max(450, buyers.length * barHeight);

  Highcharts.chart(container, {
    chart: { type: "bar", height: calculatedHeight },
    title: { text: "" },
    legend: { enabled: false },
    credits: { enabled: false },

    // xAxis: { categories: buyers },
        xAxis: { 
    categories: buyers,
    labels: {
        useHTML: true,
        formatter: function() {
        return '<div style="width:150px;text-align:right;line-height:1.2;word-wrap:break-word;white-space:normal;padding:5px 0;">' + 
                this.value + 
                '</div>';
        }
    }
    },
    yAxis: {
      min: 0,
      title: { text: "Quantity (Kgs)" },
      stackLabels: {
        enabled: true,
        formatter: function () {
          return this.total ? this.total.toLocaleString() : "";
        },
        style: {
          fontWeight: "bold",
          color: "#000",
          fontSize: "12px"
        },
        x: 10
      }
    },

    plotOptions: {
      bar: {
        stacking: "normal",
        pointPadding: 0.1,
        groupPadding: 0.2,
        borderRadius: 3,
        borderWidth: 0,
        pointWidth: 35,

        dataLabels: {
          enabled: true,
          inside: true,
          formatter: function () {
            const ctx: any = this;
            const point = ctx.point;

            if (!point.shapeArgs?.height) return null;

            const barSize = point.shapeArgs.height;
            const text = String(ctx.y.toLocaleString());
            const textSize = text.length * 7;

            return textSize + 6 < barSize ? text : null;
          },
          style: {
            color: "#ffffff",
            fontSize: "12px",
            fontWeight: "bold",
            textOutline: "none"
          }
        }
      }
    },

    tooltip: {
      formatter: function (this: any) {
        const p = this.point.options?.customData;
        if (!p) return false;

        return `
          <b>${p.subtype}</b><br/>
          Quantity: <b>${p.quantity.toLocaleString()} Kgs</b><br/>
          Avg Price: <b>₹ ${p.avg_price.toLocaleString()}</b><br/>
          Total Value: <b>₹ ${p.total_value.toLocaleString()}</b>
        `;
      }
    },

    series
  });
}

renderDateGraph() {
  const container = document.getElementById("incomingGraphContainer");
  if (!container) return;

  const data = this.state.materialGraphData;
  if (!data || data.length === 0) {
    Highcharts.chart(container, {
      title: {
        text: "No data available",
        y: 180,
        style: { color: "#999", fontSize: "16px" }
      },
      credits: { enabled: false }
    });
    return;
  }

  const dates = data.map((d: any) =>
    format(new Date(d.date), "MMM dd")
  );

  const fallbackColors = [
    "#3B3EAC", "#56B1BF", "#FE9C78", "#C84B31",
    "#FFC85B", "#2F2E41", "#7C9797"
  ];

  let colorIndex = 0;
  const series: any[] = [];

  data.forEach((dateItem: any, dateIndex: number) => {
    dateItem.materials.forEach((material: any) => {
      material.subtypes.forEach((sub: any) => {

        const totalQuantity = sub.buyers.reduce(
          (sum: number, b: any) => sum + Number(b.quantity || 0),
          0
        );

        const vendorDetails = sub.buyers.map((b: any) => ({
          vendor: b.buyer,
          quantity: Number(b.quantity),
          avg_price: Number(b.avg_price_per_unit),
          total_value: Number(b.total_value)
        }));

        series.push({
          type: "bar",
          name: sub.subtype,
          color: fallbackColors[colorIndex % fallbackColors.length],
          data: dates.map((_: any, i: number) =>
            i === dateIndex
              ? {
                  y: totalQuantity,
                  customData: vendorDetails
                }
              : 0
          )
        });

        colorIndex++;
      });
    });
  });

  const barHeight = 50;
  const calculatedHeight = Math.max(450, dates.length * barHeight);

  Highcharts.chart(container, {
    chart: {
      type: "bar",
      height: calculatedHeight
    },

    title: { text: "" },
    credits: { enabled: false },
    legend: { enabled: false },

    xAxis: {
      categories: dates
    },

    yAxis: {
      min: 0,
      title: { text: "Quantity (Kgs)" },

      // ✅ STACK TOTAL LABEL (Fixed)
      stackLabels: {
        enabled: true,
        formatter: function () {
          const ctx: any = this;
          return ctx.total ? ctx.total.toLocaleString() : "";
        },
        style: {
          fontWeight: "bold",
          color: "#000",
          fontSize: "12px"
        },
        x: 10
      }
    },

    plotOptions: {
      bar: {
        stacking: "normal",  
        pointPadding: 0.1,
        groupPadding: 0.2,
        borderRadius: 3,
        borderWidth: 0,
        pointWidth: 35,

        dataLabels: {
          enabled: true,
          inside: true,
          formatter: function () {
            const ctx: any = this;
            const point = ctx.point;

            if (!point.shapeArgs?.height) return null;

            const barSize = point.shapeArgs.height;
            const text = String(ctx.y.toLocaleString());
            const textSize = text.length * 7;

            return textSize + 6 < barSize ? text : null;
          },
          style: {
            color: "#ffffff",
            fontSize: "12px",
            fontWeight: "bold",
            textOutline: "none"
          }
        }
      }
    },

    tooltip: {
      formatter: function () {
        const ctx: any = this;
        const vendors = ctx.point.options?.customData;

        if (!vendors) return false;

        let vendorHtml = "";

        vendors.forEach((v: any) => {
          vendorHtml += `
            <b>${v.vendor}</b><br/>
            Qty: <b>${v.quantity.toLocaleString()} Kgs</b><br/>
            Avg Price: <b>₹ ${v.avg_price.toLocaleString()}</b><br/>
            Total Value: <b>₹ ${v.total_value.toLocaleString()}</b><br/><br/>
          `;
        });

        return `
          <b>${ctx.series.name}</b><br/>
          Total: <b>${ctx.y.toLocaleString()} Kgs</b><br/><br/>
          ${vendorHtml}
        `;
      }
    },

    series
  });
}

       renderMaterialGraph() {
        const container = document.getElementById("incomingGraphContainer");
        if (!container) return; 
      const data = this.state.materialGraphData;
       if (!data || data.length === 0) {
            Highcharts.chart(container, {
            title: {
                text: "No data available",
                y: 180,
                style: { color: "#999", fontSize: "16px" }
            },
            credits: { enabled: false }
            });
            return;
        }
    
       const fallbackColors = [
      "#3B3EAC", "#56B1BF", "#FE9C78", "#C84B31", "#FFC85B", "#2F2E41", "#7C9797", "#CCA85A", "#FF8F66"
    ];
    
      const hcColors = fallbackColors;
    
      const materialTypes = data.map((item: any) => item.type);
      const series: any[] = [];
    
      let colorIndex = 0;
    
      data.forEach((item: any, typeIndex: number) => {
        [...(item.subtypes|| [])].reverse().forEach((sub: any) => {
          series.push({
            type: "bar",
            name: sub.subtype,
            data: data.map((_: any, rIndex: number) =>
              rIndex === typeIndex ? sub.total : null
            ),
            color: hcColors[colorIndex % hcColors.length],
          });
          colorIndex++;
        });
      });
    
    Highcharts.chart(container, {
        chart: { type: "bar", height: 450 },
        title: { text: "" },

        legend: { enabled: false },

        xAxis: { categories: materialTypes },
        // yAxis: { min: 0, title: { text: "Values" } },
        yAxis: {
            min: 0,
            title: { text: "Values" },

            stackLabels: {
            enabled: true,
            allowOverlap: false,
            crop: true,
            overflow: "justify",

            formatter: function () {
                const ctx = this as any;
                const text = ctx.total ? ctx.total.toLocaleString() : "";

                // Optional: hide very large totals if needed
                // return text.length > 6 ? "" : text;
                return text;
            },

            style: {
                fontWeight: "bold",
                color: "#000",
                fontSize: "12px",
            },

            x: 10   // spacing after bar
            }
        },


        plotOptions: {
            bar: {
            stacking: "normal",

            pointPadding: 0.1,
            groupPadding: 0.2,
            borderRadius: 3,
            borderWidth: 0,

            pointWidth: 35,
            // minPointLength: 25, 

            dataLabels: {
                enabled: true,
                inside: true,
                allowOverlap: false,
                crop: true,
                formatter: function () {
                const ctx = this as any;
                const point = ctx.point as Highcharts.Point & {
                    shapeArgs?: { height?: number };
                };

                if (!point.shapeArgs?.height) return null;

                // In bar charts, height is the usable space
                const barSize = point.shapeArgs.height;

                const text = String(ctx.y.toLocaleString());
                const textSize = text.length * 7; // approx px width

                return textSize + 6 < barSize ? text : null;
                },


                style: {
                color: "#ffffff",
                fontSize: "12px",
                fontWeight: "bold",
                textOutline: "none",
                },
            },
            },
        },


        tooltip: {
            formatter: function (this: any) {
            return `
                    <b>${this.series.name}</b><br/>
                    Value: <b>${this.y.toLocaleString()}</b>
                    `;
            },
        },

        series,
    });
    }
      public fetchOutgoingWasteTypeSummary() {
      this.setState({ graphLoading: true });
      const params: any = {
        hierarchies: this.props.user.selectedHierarchyIds,
        start_date: this.state.customFromDate
          ? formatDate(this.state.customFromDate, "Y-m-d")
          : "",
        end_date: this.state.customToDate
          ? formatDate(this.state.customToDate, "Y-m-d")
          : "",
        group_by: this.state.graphType
      };
    
      axios
        .get("outGoingWasteTypeSummary", { params })
        .then((res: any) => {
          this.setState({ materialGraphData: res.data.data || [],
        graphLoading: false,dateFilterLoading: false }, () => {
            this.renderGraph();
          });
        })
        .catch((err) => {
          this.setState({ graphLoading: false, materialGraphData: [],dateFilterLoading: false });
          toast.error("Failed to load graph data");
        });
    }
    

    public fetchOutGoingWasteList(page: number = 0, limit: number = this.state.pageSize) {
        if (this.props.user.selectedHierarchyIds.length) {
            this.setState({ showLoader: true,currentPage:page });
            let selectedRoute = (this.state.filter_route_id) ? this.state.routes[this.state.filter_route_id] : {};
            let options: any = { "community_id": null, "hierarchies": this.props.user.selectedHierarchyIds, filter: this.state.filter, "type": "all", "page": page + 1, "limit": limit, start_date : (this.state.customFromDate) ? formatDate(this.state.customFromDate, 'Y-m-d') : "", end_date : (this.state.customToDate) ? formatDate(this.state.customToDate, 'Y-m-d') : ""}
            if (this.state.filter_route_id && this.state.filter_route_id != "all") {
                options['selectedDropDown[id]'] = (this.state.filter_route_id) ? selectedRoute.id : '';
                options['selectedDropDown[hierarchy_id]'] = (this.state.filter_route_id) ? selectedRoute.hierarchy_id : '';
            } else {
                options['selectedDropDown'] = '';
            }
            console.log('options', options);
            axios.get(`outGoingWasteList`, { params: options }).then((response: any) => {
                this.setState({ showLoader: false });
                let data: any = response.data.data.data;
                let outGoingWasteList: any = [];
                data.map((outGoingWaste: any) => {
                    outGoingWasteList.push({
                        "id": outGoingWaste.id,
                        // "route": outGoingWaste.route_name,
                        "route_id": outGoingWaste.route_id,
                        "hierarchy_id": outGoingWaste.hierarchy_id,
                        "type": outGoingWaste.outgoing_waste_type,
                        "type_id": outGoingWaste.sorted_waste_for_storage_type_id,
                        "weight": outGoingWaste.quantity,
                        "unit": outGoingWaste.unit,
                        "unit_id": outGoingWaste.unit_id,
                        "material": outGoingWaste.outgoing_waste_type_material,
                        "price_per_unit": outGoingWaste.price,
                        "total_price": outGoingWaste.total_price,
                        "buyer_name": outGoingWaste.buyer,
                        buyer_id: outGoingWaste.buyer_id,
                        "invoice_no": outGoingWaste.invoice_no, 
                        "gst": outGoingWaste.gst,
                        // "receipt_id": outGoingWaste.receipt_id,
                        "description": outGoingWaste.description,
                        "created_at": outGoingWaste.created_at,
                        "updated_at": outGoingWaste.updated_at
                    });
                });
                this.setState({ outGoingWasteList: outGoingWasteList, rowCount: response.data.data.total, showCustomDateFilter: false });
            }).catch((error) => {
                this.setState({
                    showLoader: false
                });
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }
    }
    public fetchBuyers() {
    axios.get("listBuyers", {
        params: { hierarchy_ids: this.props.user.selectedHierarchyIds }
    }).then((response: any) => {
        if (response.data.success) {
            this.setState({ buyers: response.data.data || [] });
        }
    }).catch(() => {
        toast.error("Failed to fetch buyers");
    });
    }


    public fetchRoutes() {
        axios.get(`allCommunitiesWithHierarchyLite`, { params: { "hierarchies": this.props.user.selectedHierarchyIds } }).then(response => {
            let data: any = response.data.data;
            let routes: any = [];
            let hierarchies: any = [];
            data.map((route: any) => {
                if (!hierarchies[route.hierarchy_id]) {
                    hierarchies[route.hierarchy_id] = {
                        "id": route.hierarchy_id,
                        "name": route.hierarchy_name,
                        routes: []
                    };
                    hierarchies[route.hierarchy_id].routes.push({
                        "type": "route",
                        "id": route.id,
                        "route": route.name,
                        "hierarchy_id": route.hierarchy_id,
                        "hierarchy_name": route.hierarchy_name
                    });
                } else {
                    hierarchies[route.hierarchy_id].routes.push({
                        "type": "route",
                        "id": route.id,
                        "route": route.name,
                        "hierarchy_id": route.hierarchy_id,
                        "hierarchy_name": route.hierarchy_name
                    });
                }
            });
            hierarchies.map((hierarchy: any) => {
                routes.push({
                    "type": "hierarchy",
                    "id": "all",
                    "route": hierarchy.name,
                    "hierarchy_id": hierarchy.id,
                    "hierarchy_name": hierarchy.name
                });
                routes.push({
                    "type": "multiple_routes",
                    "id": "all",
                    "route": "Multiple Routes",
                    "hierarchy_id": hierarchy.id,
                    "hierarchy_name": hierarchy.name
                });
                // hierarchy.routes.map((route: any) => {
                //     routes.push({
                //         "type": "route",
                //         "id": route.id,
                //         "route": route.route,
                //         "hierarchy_id": route.hierarchy_id,
                //         "hierarchy_name": route.hierarchy_name
                //     });
                // });
            });
            this.setState({ routes: routes });
        });
    }

    public fetchUnits() {
        axios.get(`getUnits`, { params: { "hierarchies": this.props.user.selectedHierarchyIds } }).then(response => {
            let data: any = response.data.data;
            this.setState({ units: data });
        });
    }

    public fetchMaterialTypes() {
        if (this.props.user.selectedHierarchyIds.length) {
            this.setState({ showLoader: true });
            let options = { "hierarchies": this.props.user.selectedHierarchyIds }
            axios.get(`subTypesOfMaterial`, { params: options }).then((response: any) => {
                this.setState({ showLoader: false });
                let material_types: any = response.data.data;
                this.setState({ material_types: material_types });
            });
        }
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);

        const handleMoreOptions = (event: React.MouseEvent<HTMLElement>) => {
            this.setState({ anchorEl: event.currentTarget });
        };

        const handleExportToCsv = () => {


            const date = new Date();
            const Offset = date.getTimezoneOffset();

            this.setState({ showLoader: false });
      let data: any = {
        startDate: this.state.fromDate
          ? formatDate(this.state.fromDate, "Y-m-d")
          : "",
        endDate: this.state.toDate
          ? formatDate(this.state.toDate, "Y-m-d")
          : "",
        hierarchies: this.props.user.selectedHierarchyIds,
      };
      let url = "/node/new/api/outgoingWastesExport";
      if (axios.defaults.baseURL) {
        let currentBaseURL: string = axios.defaults.baseURL;
        currentBaseURL = currentBaseURL.split("/").slice(0, 3).join("/");
        url = currentBaseURL + url;
      }
      axios({
        url:
          url +
          "/" +
          data.startDate +
          "/" +
          data.endDate +
          "/" +
          data.hierarchies
          + "/" +
          Offset,
        method: "GET",
        responseType: "blob", // important
      })
        .then((response) => {
          var fileName =
            "outgoingWaste" + data.startDate + "_" + data.endDate + ".csv";
          fileDownload(response.data, fileName);
          if (response.data.success) {
            toast.success(response.data.success, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          } else {
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        })
        .catch((error) => {
          this.setState({ showLoader: false });
          toast.error(error.response.data.msg, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
        };

        const handleAddWaste = ((event: any) => {
            event.preventDefault();
            this.setState({ showLoader: true });
            let datetime: any = this.state.date ? formatDate(this.state.date, 'Y-m-d') + " "+ (this.state.time ? formatTime(this.state.time, 'H:i:s') : "00:00:00") : "";
            let data: any = {
                route: this.state.routes[this.state.route_id],
                quantity: this.state.waste_quantity,
                unit: this.state.unit,
                typeOfSortedWaste: this.state.material_type,
                price: this.state.price_per_unit,
                totalPrice: this.state.total_price,
                invoice_no: this.state.invoice_no, 
                gst: this.state.gst,   
                buyer_id: this.state.buyer,      
                buyer: this.state.buyer_name, 
                receipt_id: this.state.receipt_id,
                datetime: datetime,
                description: this.state.description,
                hierarchies: this.props.user.selectedHierarchyIds
            };
            if (this.state.entryId) {
                data.id = this.state.entryId;
                data.typeOfSortedWasteMaterial = this.state.material;
            } else {
                // data.route = this.state.routes[this.state.route_id];
                data.typeOfSortedWasteMaterialList = this.state.material;
            }
            axios.post(`addUpdateOutGoingWaste`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                if (response.data.success) {
                    handleClearAddWaste();
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.fetchOutGoingWasteList();
                } else {
                    handleClearAddWaste();
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                handleClearAddWaste();
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        });

        const handleClearAddWaste = (showAddWaste: boolean = false) => {
            this.setState({
                showAddWaste: showAddWaste,
                entryId: "",
                route_id: "",
                waste_quantity: 0,
                unit: "",
                material: "",
                material_type: "",
                price_per_unit: 0,
                total_price: 0,
                buyer: "",
                receipt_id: "",
                invoice_no: "",
                gst: "",
                date: null,
                time: formatDate(formatDate(new Date(), "Y-m-d")+" 00:00:00", "Y-m-d H:i:s"),
                description: "",
                types: [],
                showLoader: false
            });
        }

        const handleEditEntry = (entry: any) => {
            this.setState({
                showAddWaste: true,
                entryId: entry.id,
                route_id: (entry.route_id) ? this.state.routes.findIndex((route) => (route.id == entry.route_id && route.hierarchy_id == entry.hierarchy_id && (route.type == "multiple_routes" || route.type == "route"))): "",
                waste_quantity: entry.weight,
                unit: entry.unit_id,
                material: entry.material,
                types: this.state.material_types[entry.material],
                material_type: entry.type_id,
                invoice_no: entry.invoice_no,
                gst: entry.gst,
                price_per_unit: entry.price_per_unit,
                total_price: entry.total_price,
                buyer: entry.buyer_id,
                buyer_name: entry.buyer_name,
                receipt_id: entry.receipt_id,
                date: entry.created_at,
                time: entry.created_at,
                description: entry.description
            })
        }

        const handleDeleteEntry = () => {
            this.setState({ showLoader: true });
            let data = {
                id: this.state.outgoingWasteId
            };
            axios.post(`deleteOutGoingWaste`, data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
                this.setState({ showDeleteDialog: false, outgoingWasteId: "", showLoader: false });
                toast.success(t("Entry Deleted Successfully"), {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
                this.fetchOutGoingWasteList();
            }).catch((error) => {
                this.setState({ showDeleteDialog: false, outgoingWasteId: "", showLoader: false });
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        };

        const handleOutgoingWasteFlowDurationChange = (duration: string) => {
            this.setState({ outgoingWasteFlowDuration: duration });
            this.setState({ showCustomDateFilter: true, durationType: 'materialFlow' });
        };

        const columns: any = [
            // {
            //     headerName: "Route",
            //     field: "route",
            //     width: 150,
            //     renderCell: (params: GridCellParams) => (
            //         <Link to={`/routes/${params.id}`} style={{ textDecoration: 'none' }}>{params.row.route}</Link>
            //     )
            // },
            {
                headerName: "Id",
                field: "id",
                width: 80
            },
            {
                headerName: t("Type"),
                field: "type",
                width: 120
            },
            {
                headerName: t("Weight"),
                field: "weight",
                width: 80,
                renderCell: (params: GridCellParams) => (
                    <div>{parseFloat(params.row.weight.toString()).toLocaleString()}</div>
                )
            },
            {
                headerName: t("Unit"),
                field: "unit",
                width: 80
            },
            {
                headerName: t("Material"),
                field: "material",
                width: 100
            },
            {
                headerName: t("Buyer"),
                field: "buyer_name",
                width: 150
            },
            {
                headerName: t("Invoice No"),
                field: "invoice_no",
                width: 120
            },
            {
                headerName: t("GST"),
                field: "gst",
                width: 80
            },
            // {
            //     headerName: "Id",
            //     field: "id",
            //     width: 80
            // },
            {
                headerName: t("Created At"),
                field: "created_at",
                type: "dateTime",
                width: 150
            },
            {
                headerName: t("Updated At"),
                field: "updated_at",
                type: "dateTime",
                width: 150
            },
            {
                headerName: t("Actions"),
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        // icon={<FileCopyIcon />}    
                        label={t("Edit Outgoing Waste")}
                        onClick={() => handleEditEntry(params.row)}
                        showInMenu
                    />,
                    <GridActionsCellItem
                        label="Delete"
                        onClick={() => this.setState({ outgoingWasteId: params.id.toString(), showDeleteDialog: true })}
                        showInMenu
                    />
                ]
            }
        ];

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
<DiversionHeader user={this.props.user} />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Outgoing Waste")}</Typography>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.fetchOutGoingWasteList())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="routes-select-label">{t("Community")}</InputLabel>
                                                <Select
                                                    labelId="routes-select-label"
                                                    value={this.state.filter_route_id}
                                                    onChange={(e) => this.setState({ filter_route_id: e.target.value }, () => this.fetchOutGoingWasteList())}
                                                    displayEmpty
                                                    label={t("Community")}
                                                    fullWidth={true}
                                                >
                                                    <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                                                    {
                                                        this.state.routes.map((route, key) => {
                                                            if (route.type == "hierarchy") {
                                                                return <MenuItem key={key} value={key} disabled={true}>{route.route}</MenuItem>;
                                                            } else if (route.type == "multiple_routes") {
                                                                return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                                                            } else {
                                                                return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                                                            }
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size='small'>
                                                <Button variant="contained" size="small" sx={{ marginTop: "5px" }} className={(this.state.outgoingWasteFlowDuration == 'custom') ? "active" : ""} onClick={() => handleOutgoingWasteFlowDurationChange('custom')}>{t("Date Search")}</Button>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                }
                                className="text-left"
                                action={
                                    // <IconButton aria-label="customer-more-options-button" sx={{ outline: 'none !important' }} onClick={(e: any) => handleMoreOptions(e)}>
                                    //     <MoreHorizOutlined id="customer-more-options-button" sx={{ outline: 'none !important' }} />
                                    //     <Menu
                                    //         id="customer-more-options-menu"
                                    //         aria-labelledby="customer-more-options-button"
                                    //         anchorEl={this.state.anchorEl}
                                    //         open={open}
                                    //         onClose={() => this.setState({ anchorEl: null })}
                                    //         anchorOrigin={{
                                    //             vertical: 'top',
                                    //             horizontal: 'left',
                                    //         }}
                                    //         transformOrigin={{
                                    //             vertical: 'top',
                                    //             horizontal: 'left',
                                    //         }}
                                    //     >
                                    //         <MenuItem className='customMenuItem' onClick={() => this.setState({ anchorEl: null })}>Synchronise</MenuItem>
                                    //         <MenuItem className='customMenuItem' onClick={() => this.setState({ anchorEl: null })}>Export List</MenuItem>
                                    //         <MenuItem className='customMenuItem' onClick={() => this.setState({ anchorEl: null })}>Reset List</MenuItem>
                                    //     </Menu>
                                    // </IconButton>
                                    <CardActions>
                                        {/* <Button variant="contained" size="small" className="viewHistoricalCharts" sx={{ marginRight: "8px" }} component={Link} to={'/outgoing-waste-charts'}>{t("View Historical Charts")}</Button> */}
                                        <Button variant="contained" size="small" sx={{ outline: 'none !important' }} onClick={() => this.setState({ showExportToCsv: true })}>{t("Export To CSV")}</Button>
                                    </CardActions>
                                }
                            />
                            <CardActions>
                                <Button variant='contained' sx={{ outline: 'none !important' }} onClick={() => { this.setState({ showAddWaste: true }); handleClearAddWaste(true); }}><Add /> {t("Add Outgoing Waste")}</Button>
                                {(
                                  isEmailAllowed(this.props.user.email) 
                                ) && (
                                 <Button
                                    variant="contained"
                                    sx={{ outline: "none !important" }}
                                    onClick={() => {
                                    this.setState({ showMaterialGraph: true }, () => {
                                        this.fetchOutgoingWasteTypeSummary();
                                    });
                                    }}
                                >
                                    Show Material Graph
                                </Button>)}
                            </CardActions>
                            <CardContent>
                                <DataGrid
                                    aria-label={t("Outgoing Waste List")}
                                    columns={columns}
                                    rows={this.state.outGoingWasteList}
                                    rowCount={this.state.rowCount}
                                    pageSize={this.state.pageSize}
                                    onPageChange={(page) => this.fetchOutGoingWasteList(page)}
                                    onPageSizeChange={(newPageSize) => { this.setState({ pageSize: newPageSize }); this.fetchOutGoingWasteList(0, newPageSize); }}
                                    rowsPerPageOptions={[10, 20, 50, 100]}
                                    autoHeight={true}
                                    pagination
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Pagination: () => (
                                            <CustomPagination
                                                count={Math.ceil(this.state.rowCount / this.state.pageSize)}
                                                page={this.state.currentPage+1}
                                                onChange={(event, page) => this.fetchOutGoingWasteList(page-1)}
                                              
                                            />
                                        )
                                    }}
                                    paginationMode="server"
                                    componentsProps={{ toolbar: { csvOptions: { fileName: 'Outgoing-waste-list' } } }}
                                    // checkboxSelection
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showAddWaste}
                    onClose={() => this.setState({ showAddWaste: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card component={'form'} onSubmit={(event: any) => handleAddWaste(event)}>
                            <CardHeader
                                title={(!this.state.entryId) ? t("Add Waste") : t("Edit Entry")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddWaste: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("Date") + " *"}
                                                    value={this.state.date}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ date: newValue });
                                                    }}
                                                    disableFuture={true}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <TimePicker
                                                    inputFormat="HH:mm"
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("Time")}
                                                    value={this.state.time}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ time: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    {
                                        // (!this.state.entryId) &&
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true}>
                                                <InputLabel id="routes-select-label">{t("Community")} *</InputLabel>
                                                <Select
                                                    labelId="routes-select-label"
                                                    value={this.state.route_id}
                                                    onChange={(e) => this.setState({ route_id: e.target.value })}
                                                    displayEmpty
                                                    label={t("Community") + " *"}
                                                    fullWidth={true}
                                                >
                                                    {
                                                        this.state.routes.map((route, key) => {
                                                            if (route.type == "hierarchy") {
                                                                return <MenuItem key={key} value={key} disabled={true}>{route.route}</MenuItem>;
                                                            } else if (route.type == "multiple_routes") {
                                                                return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                                                            } else {
                                                                return <MenuItem key={key} value={key}>&nbsp;&nbsp;{route.route}</MenuItem>;
                                                            }
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    }
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="material-select-label">{t("Material")} *</InputLabel>
                                            <Select
                                                labelId="material-select-label"
                                                value={this.state.material}
                                                onChange={(e) => this.setState({ material: e.target.value, material_type: "", types: this.state.material_types[e.target.value] })}
                                                displayEmpty
                                                label={t("Material") + " *"}
                                                fullWidth={true}
                                            >
                                                {
                                                    Object.keys(this.state.material_types).map(function (key) {
                                                        return <MenuItem key={key} value={key}>{key}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="material-types-select-label">{t("Type")} *</InputLabel>
                                            <Select
                                                labelId="material-types-select-label"
                                                value={this.state.material_type}
                                                onChange={(e) => this.setState({ material_type: e.target.value })}
                                                displayEmpty
                                                label={t("Type") + " *"}
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.types.map((type: any) => {
                                                        return <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        {/* <TextField
                                            id="waste-quantity-input"
                                            label={t("WasteQuantity") + " *"}
                                            value={this.state.waste_quantity}
                                            type="number"
                                            onChange={(e: any) => this.setState({ waste_quantity: e.target.value })}
                                            fullWidth={true}
                                        /> */}
                                        {/* to convert simple number 1234 to thousand separator 1,234 */}
                                        <NumericFormat
                                            type="text"
                                            label={t("Waste Quantity") + " *"}
                                            value={this.state.waste_quantity}
                                            customInput={TextField}
                                            thousandsGroupStyle="thousand"
                                            onChange={(e: any) => this.setState({ waste_quantity: parseFloat(e.target.value.replace(/,/g, ''))})}
                                            thousandSeparator=","
                                            fullWidth={true}
                                            />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="unit-label">{t("Unit")} *</InputLabel>
                                            <Select
                                                labelId="unit-label"
                                                value={this.state.unit}
                                                onChange={(e) => this.setState({ unit: e.target.value })}
                                                displayEmpty
                                                label={t("Unit") + " *"}
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.units.map((unit) => {
                                                        return <MenuItem key={unit.id} value={unit.id}>{unit.name}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        {/* <TextField
                                            id="price-per-unit-input"
                                            label={t("PricePerUnit") + " *"}
                                            value={this.state.price_per_unit?.toLocaleString()}
                                            type="text"
                                            InputProps={{
                                                // inputProps: { min: 0, max: 100000000 }
                                            }}
                                            onChange={(e: any) => this.setState({ price_per_unit: e.target.value, total_price: ((this.state.waste_quantity) ? (this.state.waste_quantity * e.target.value) : 0) })}    
                                            fullWidth={true}
                                        /> */}
                                        {/* to convert simple number 1234 to thousand separator 1,234 */}
                                        <NumericFormat
                                            type="text"
                                            label={t("Price Per Unit") + " *"}
                                            value={this.state.price_per_unit}
                                            customInput={TextField}
                                            thousandsGroupStyle="thousand"
                                            onChange={(e: any) => this.setState({ price_per_unit: parseFloat(e.target.value.replace(/,/g, '')), total_price: ((this.state.waste_quantity) ? (this.state.waste_quantity * parseFloat(e.target.value.replace(/,/g, ''))) : 0) })}
                                            thousandSeparator=","
                                            fullWidth={true}
                                            />
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <TextField
                                            id="total-price-input"
                                            label={t("Total Price") + " *"}
                                            value={this.state.total_price ? this.state.total_price.toLocaleString() : ''}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                   <Grid item md={4} xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="buyer-select-label">
                                                {t("Buyer")} *
                                            </InputLabel>

                                            <Select
                                                labelId="buyer-select-label"
                                                value={this.state.buyer}
                                                label={t("Buyer") + " *"}
                                                onChange={(e) => {
                                                    const selectedBuyer = this.state.buyers.find(
                                                        (b: any) => b.id === e.target.value
                                                    );

                                                    this.setState({
                                                        buyer: e.target.value,
                                                        buyer_name: selectedBuyer?.buyer_company_name || ''
                                                    });
                                                }}
                                            >
                                                {this.state.buyers.map((buyer: any) => (
                                                    <MenuItem key={buyer.id} value={buyer.id}>
                                                        {buyer.buyer_company_name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <TextField
                                                id="receipt-id-input"
                                                label={t("Invoice No") + " *"}
                                                value={this.state.invoice_no}
                                                onChange={(e: any) => this.setState({ invoice_no: e.target.value })}
                                                fullWidth={true}
                                            />
                                        </FormControl>
                                    </Grid>
                                      <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="gst-select-label">{t("GST(%)")} *</InputLabel>
                                            <Select
                                                labelId="gst-select-label"
                                                value={this.state.gst}
                                                onChange={(e) => this.setState({ gst: e.target.value })}
                                                label={t("GST(%)")+"*"}
                                                fullWidth={true}
                                            >
                                                <MenuItem value="5">5%</MenuItem>
                                                <MenuItem value="12">12%</MenuItem>
                                                <MenuItem value="18">18%</MenuItem>
                                                <MenuItem value="NA">NA</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={8} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <TextField
                                                id="description-input"
                                                label={t("Description") + " (" + t("Optional") + ")"}
                                                value={this.state.description}
                                                onChange={(e: any) => this.setState({ description: e.target.value })}
                                                fullWidth={true}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddWaste: false })}>{t("Close")}</Button>
                                <Button size='small' type='submit' variant='contained' sx={{ outline: 'none !important' }}>{(!this.state.entryId) ? t("Add") : t("Edit")} {t("Waste")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showCustomDateFilter}
                    onClose={() => this.setState({ showCustomDateFilter: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Select Custom Analytics Dates")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showCustomDateFilter: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("From Date") + " *"}
                                                    value={this.state.customFromDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ customFromDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("To Date") + " *"}
                                                    value={this.state.customToDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ customToDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showCustomDateFilter: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} disabled={!this.state.customFromDate || !this.state.customToDate} onClick={() => { (this.state.durationType == 'materialFlow') ? this.fetchOutGoingWasteList() : this.fetchOutGoingWasteList() }}>{t("Get Analytics")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                <Modal
                    open={this.state.showExportToCsv}
                    onClose={() => this.setState({ showExportToCsv: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title={t("Export Data")}
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showExportToCsv: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("From Date") + " *"}
                                                    value={this.state.fromDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ fromDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={6} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DatePicker
                                                    inputFormat="yyyy-MM-dd"
                                                    views={['year', 'month', 'day']}
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label={t("To Date") + " *"}
                                                    value={this.state.toDate}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ toDate: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showExportToCsv: false })}>{t("Close")}</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} disabled={(!this.state.fromDate || !this.state.toDate)} onClick={() => handleExportToCsv()}>{t("Download")}</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
                 <Modal
                          open={this.state.showMaterialGraph}
                          onClose={() => this.setState({ showMaterialGraph: false })}
                        >
                          <Box sx={{
                              position: 'absolute',
                              top: '50%',
                              left: '50%',
                              transform: 'translate(-50%, -50%)',
                              width: '85%',
                              maxHeight: '90vh',
                              overflowY: 'auto',
                              bgcolor: 'white',
                              p: 3
                          }}>
                              
                              {/* TITLE */}
                              <Typography variant="h6" sx={{ mb: 2 }}>
                                Outgoing Waste Report
                              </Typography>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 ,alignItems: "center"}}>
                                {/* LEFT SIDE — GRAPH TYPE BUTTONS */}
                                <ButtonGroup
                                  variant="contained"
                                  className="diversionButtonGroup"
                                >
                                  <Button
                                    className={this.state.graphType === "material" ? "active" : ""}
                                    onClick={() =>
                                      this.setState({ graphType: "material" }, () =>
                                        this.fetchOutgoingWasteTypeSummary()
                                      )
                                    }
                                  >
                                  {this.state.dateFilterLoading && this.state.graphType === "material" ? (
                                          <CircularProgress size={20} style={{ color: 'white' }} />
                                      ) : (
                                          'Material'
                                  )}
                                  </Button>

                                  <Button
                                    className={this.state.graphType === "buyer" ? "active" : ""}
                                    onClick={() =>
                                      this.setState({ graphType: "buyer" }, () =>
                                        this.fetchOutgoingWasteTypeSummary()
                                      )
                                    }
                                  >
                                    {this.state.dateFilterLoading && this.state.graphType === "buyer" ? (
                                            <CircularProgress size={20} style={{ color: 'white' }} />
                                        ) : (
                                            'Buyer'
                                    )}
                                  </Button>

                                  <Button
                                    className={this.state.graphType === "date" ? "active" : ""}
                                    onClick={() =>
                                      this.setState({ graphType: "date" }, () =>
                                        this.fetchOutgoingWasteTypeSummary()
                                      )
                                    }
                                  >
                                    {this.state.dateFilterLoading && this.state.graphType === "date" ? (
                                            <CircularProgress size={20} style={{ color: 'white' }} />
                                        ) : (
                                            'Date'
                                    )}
                                  </Button>
                                </ButtonGroup>
                                <ButtonGroup variant="contained" className="diversionButtonGroup float-right">
                
                                  {/* TODAY */}
                                  <Button
                                    className={this.state.graphDuration === 'today' ? 'active' : ''}
                                    onClick={() => {
                                      const today = format(new Date(), "yyyy-MM-dd");
                
                                      this.setState(
                                        {
                                          graphDuration: 'today',
                                          customFromDate: today,
                                          customToDate: today
                                        },
                                        () => this.fetchOutgoingWasteTypeSummary()
                                      );
                                    }}
                                  >
                                   {this.state.dateFilterLoading && this.state.graphDuration === 'today' ? (
                                      <CircularProgress size={20} style={{ color: 'white' }} />
                                  ) : (
                                      'Today'
                                  )}
                                  </Button>
                
                                  {/* WEEK */}
                                  <Button
                                    className={this.state.graphDuration === 'week' ? 'active' : ''}
                                    onClick={() => {
                                      const start = format(startOfWeek(new Date(), { weekStartsOn: 1 }), "yyyy-MM-dd");
                                      const end = format(endOfWeek(new Date(), { weekStartsOn: 1 }), "yyyy-MM-dd");
                
                                      this.setState(
                                        {
                                          graphDuration: 'week',
                                          customFromDate: start,
                                          customToDate: end
                                        },
                                        () => this.fetchOutgoingWasteTypeSummary()
                                      );
                                    }}
                                  >
                                    {this.state.dateFilterLoading && this.state.graphDuration === 'week' ? (
                                        <CircularProgress size={20} style={{ color: 'white' }} />
                                    ) : (
                                        'Week'
                                    )}
                                  </Button>
                
                                  {/* CURRENT MONTH */}
                                  <Button
                                    className={this.state.graphDuration === 'current_month' ? 'active' : ''}
                                    onClick={() => {
                                      const start = format(startOfMonth(new Date()), "yyyy-MM-dd");
                                      const end = format(endOfMonth(new Date()), "yyyy-MM-dd");
                
                                      this.setState(
                                        {
                                          graphDuration: 'current_month',
                                          customFromDate: start,
                                          customToDate: end
                                        },
                                        () => this.fetchOutgoingWasteTypeSummary()
                                      );
                                    }}
                                  >
                                    {this.state.dateFilterLoading && this.state.graphDuration === 'current_month' ? (
                                        <CircularProgress size={20} style={{ color: 'white' }} />
                                    ) : (
                                        'Current Month'
                                    )}
                                  </Button>
                
                                  {/* LAST MONTH */}
                                  <Button
                                    className={this.state.graphDuration === 'month' ? 'active' : ''}
                                    onClick={() => {
                                      const lastMonth = subMonths(new Date(), 1);
                                      const start = format(startOfMonth(lastMonth), "yyyy-MM-dd");
                                      const end = format(endOfMonth(lastMonth), "yyyy-MM-dd");
                
                                      this.setState(
                                        {
                                          graphDuration: 'month',
                                          customFromDate: start,
                                          customToDate: end
                                        },
                                        () => this.fetchOutgoingWasteTypeSummary()
                                      );
                                    }}
                                  >
                                   {this.state.dateFilterLoading && this.state.graphDuration === 'month' ? (
                                      <CircularProgress size={20} style={{ color: 'white' }} />
                                  ) : (
                                      'Last Month'
                                  )}
                                  </Button>
                
                                  {/* CUSTOM */}
                                  <Button
                                    className={this.state.graphDuration === 'custom' ? 'active' : ''}
                                    onClick={() => {
                                      this.setState({ graphDuration: 'custom', showGraphCustom: true });
                                    }}
                                  >
                                    Custom
                                  </Button>
                
                                </ButtonGroup>
                              </Box>      
                              {/* HIGHCHART */}
                             {this.state.graphLoading ? (
                                <Box
                                    sx={{
                                    height: 400,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    }}
                                >
                                    <CircularProgress className="customLoader" />
                                </Box>
                                ) : (
                                // <div id="incomingGraphContainer" style={{ height: 400 }} />
                                    <Box sx={{ maxHeight: 500, overflowY: "auto" }}>
                                        <div id="incomingGraphContainer" />
                                    </Box>
                                )}                      
                              {/* CLOSE BUTTON */}
                              <IconButton 
                                onClick={() => this.setState({ showMaterialGraph: false })}
                                sx={{ position: "absolute", top: 10, right: 10 }}
                              >
                                <CloseOutlined />
                              </IconButton>
                          </Box>
                        </Modal>
                        <Modal
                  open={this.state.showGraphCustom}
                  onClose={() => this.setState({ showGraphCustom: false })}
                >
                  <Box sx={style}> 
                    <Card>
                      <CardHeader
                        title="Select Date Range"
                        action={
                          <IconButton onClick={() => this.setState({ showGraphCustom: false })}>
                            <CloseOutlined />
                          </IconButton>
                        }
                      />
                
                      <CardContent>
                        <Divider className="mb-3" />
                
                        <Grid container spacing={2}>
                          <Grid item md={6} xs={12}>
                            <FormControl fullWidth>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                  inputFormat="yyyy-MM-dd"
                                  views={['year', 'month', 'day']}
                                  mask="____-__-__"
                                  label="From Date"
                                  value={this.state.graphCustomFromDate}
                                  onChange={(newValue: any) => {
                                    this.setState({ graphCustomFromDate: newValue });
                                  }}
                                  renderInput={(params) => <TextField {...params} />}
                                />
                              </LocalizationProvider>
                            </FormControl>
                          </Grid>
                
                          <Grid item md={6} xs={12}>
                            <FormControl fullWidth>
                              <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                  inputFormat="yyyy-MM-dd"
                                  views={['year', 'month', 'day']}
                                  mask="____-__-__"
                                  label="To Date"
                                  value={this.state.graphCustomToDate}
                                  onChange={(newValue: any) => {
                                    this.setState({ graphCustomToDate: newValue });
                                  }}
                                  renderInput={(params) => <TextField {...params} />}
                                />
                              </LocalizationProvider>
                            </FormControl>
                          </Grid>
                        </Grid>
                
                        <Divider className="mt-3" />
                      </CardContent>
                
                      <CardActions className="float-right">
                        <Button 
                          size="small" 
                          onClick={() => this.setState({ showGraphCustom: false })}
                        >
                          Close
                        </Button>
                
                        <Button
                          size="small"
                          variant="contained"
                          disabled={!this.state.graphCustomFromDate || !this.state.graphCustomToDate}
                          onClick={() => {
                            this.setState(
                              {
                                customFromDate: this.state.graphCustomFromDate,
                                customToDate: this.state.graphCustomToDate,
                                showGraphCustom: false
                              },
                              () => this.fetchOutgoingWasteTypeSummary()
                            );
                          }}
                        >
                        {this.state.dateFilterLoading ? (
                            <CircularProgress size={20} style={{ color: 'white' }} />
                        ) : (
                            'Apply'
                        )}
                        </Button>
                      </CardActions>
                    </Card>
                  </Box>
                </Modal>
                <Dialog
                    open={this.state.showDeleteDialog}
                    onClose={() => this.setState({ showDeleteDialog: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {t("Are you sure ? You want to delete this Entry ?")}
                    </DialogTitle>
                    <DialogActions>
                        <Button onClick={() => this.setState({ showDeleteDialog: false })}>{t("Cancel")}</Button>
                        <Button onClick={() => handleDeleteEntry()} autoFocus>{t("Ok")}</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withRouter(withTranslation()(OutgoingWaste))